import { el } from 'redom';

import { stringToSVG } from 'utilities';

import closeButtonIconString from 'assets/images/dialog-close-button-icon.svg?raw';

const closeButtonIcon = stringToSVG(closeButtonIconString);

class DialogHeader {

  constructor(configuration) {

    const closeButton = el('button.application-button round-button', {
      type: 'button',
      onclick: configuration.onClose
    }, closeButtonIcon.cloneNode(true));

    this.el = el('div', {
      class: 'dialog-section-header-main layout-update-01-2022 dialog-section header'
    }, [
      el((configuration.tag || 'label') + '.dialog-header-text', configuration.headerText), closeButton
    ]);

  }

}

export default DialogHeader;